import React from "react";
import { FiAlignJustify } from "react-icons/fi";
import { Link,useNavigate } from "react-router-dom";
import { FaUser, FaPlane, FaMapMarkedAlt  , FaTag, FaSignOutAlt } from 'react-icons/fa';
import useAuth from "Hooks/useAuth";
import airplane from 'assets/img/navbar/airplane.png';
import promos from 'assets/img/navbar/promos.png';
import promos_sel from 'assets/img/navbar/promos_sel.png';
import viajes from 'assets/img/navbar/viajes.png';
import viajes_sel from 'assets/img/navbar/viajes_sel.png';
import home from 'assets/img/navbar/home.png';
import home_sel from 'assets/img/navbar/home_sel.png';
import close from 'assets/img/navbar/close.png';
import './style.css'


const NavbarOrange = (props) => {
  const { onOpenSidenav, brandText,activeRoute } = props;
  const navigate = useNavigate()
const { logout } = useAuth()
const handleSignOutAlt = () => {
  logout();
  navigate('/');
};
const isActiveRoute = (routeName) => {
  return routeName.includes(brandText);
};

return (
  <nav className="navy sticky top-4 z-40 flex flex-row flex-wrap items-center justify-between rounded-xl bg-white/10 p-2 backdrop-blur-xl dark:bg-[#0b14374d]">
    <div className="relative mt-[3px] flex h-[61px] w-[355px] flex-grow items-center justify-around gap-2 rounded-full bg-orange-500 px-2 py-2 shadow-xl shadow-shadow-500 dark:!bg-navy-800 dark:shadow-none md:w-[365px] md:flex-grow-0 md:gap-1 xl:w-[365px] xl:gap-2">
      <span className="flex w-full cursor-pointer text-xl text-gray-600 dark:text-white xl:hidden p-2 rounded">
        <Link to="/admin/default" className="flex flex-col items-center flex-1 text-center">
        <img src= { isActiveRoute("Perfil") ? home_sel : home} alt="Perfil" className="h-6" /> 
            {/*isActiveRoute("Perfil") && <div className="h-1 w-6 bg-gray-400 mt-1 rounded" />*/}
        </Link>
        <Link to="/admin/misviajes" className="flex flex-col items-center flex-1 text-center">
          <img src= { isActiveRoute("Mis viajes") ? viajes_sel : viajes} alt="mis viajes" className="h-6" />
            { /*isActiveRoute("Mis viajes") && <div className="h-1 w-6 bg-gray-400 mt-1 rounded" />*/}       
        </Link>
        
          <img src={airplane} alt="airplane" className="h-6" />
           
        
        <Link to="/admin/promociones" className="flex flex-col items-center flex-1 text-center"> 
        <img src= { isActiveRoute("Promociones") ? promos_sel : promos} alt="promociones" className="h-6" />                 
            {/*isActiveRoute("Promociones") && <div className="h-1 w-6 bg-gray-400 mt-1 rounded" />*/}
          
        </Link>
        <div onClick={handleSignOutAlt} className="flex flex-col items-center flex-1 text-center cursor-pointer">
          <div className={`relative`}>
          <img src= { close} alt="cerrar" className="h-6" />
            
          </div>
        </div>
      </span>
    </div>
    <img src= { close} alt="cerrar" className="h-6" />
  </nav>
  
);
};

export default NavbarOrange;
